import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { QuestionItem } from "@/react/components/Spaces/CourseSpace/Show/Lesson/Content/QuizContent/QuestionItem";
import type { Quiz } from "@/react/types/Quiz";
import type {
  QuizAttempt,
  QuizAttemptQuestion,
} from "@/react/types/QuizAttempt";
import type { QuizQuestion } from "@/react/types/QuizQuestion";

interface QuizAttemptFormProps {
  lastAttempt: QuizAttempt | null;
  quiz: Quiz;
  setIsSubmitEnabled: (isSubmitEnabled: boolean) => void;
  setOnSuccess: (onSuccess: () => void) => void;
}
export const QuizAttemptForm = ({
  quiz,
  setIsSubmitEnabled,
  lastAttempt,
  setOnSuccess,
}: QuizAttemptFormProps) => {
  const { getValues, reset } = useFormContext();
  const questions: QuizQuestion[] | QuizAttemptQuestion[] = lastAttempt
    ? lastAttempt.questions
    : quiz.questions;

  const checkQuizCompleted = () => {
    const responses = getValues("responses");
    if (!responses) return;

    const responsesWithSelectedOption = responses.filter((response: any) =>
      response.selected_options.some(
        (selectedOption: any) => selectedOption.quizzes_option_id !== undefined,
      ),
    );
    setIsSubmitEnabled(
      responsesWithSelectedOption.length === quiz.questions.length,
    );
  };

  useEffect(() => {
    setOnSuccess(() => reset);
  }, [setOnSuccess, reset]);

  useEffect(() => {
    reset();
  }, [reset, lastAttempt]);

  return (
    <div className="flex flex-col gap-8">
      {questions.map((question, questionIndex) => (
        <QuestionItem
          key={question.id}
          question={question}
          questionIndex={questionIndex}
          checkQuizCompleted={checkQuizCompleted}
          lastAttempt={lastAttempt}
        />
      ))}
    </div>
  );
};
